"use strict";
exports.__esModule = true;
exports.useTextFieldStyles = void 0;
var core_1 = require("@material-ui/core");
exports.useTextFieldStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        root: {
            backgroundColor: function (props) {
                return props.customBackgroundColor + " !important";
            },
            '&:hover, &:active, &:focus': {
                backgroundColor: function (props) {
                    return props.customBackgroundColor + " !important";
                }
            }
        }
    });
});
//# sourceMappingURL=styles.js.map